import { F_MapMarkerIndoorStandFragment } from '__generated__v2/graphql';
import { fromLatLngToCoordinates } from 'pages/special/OsloDesignFair/map/mapUtils';
import { calculateRectangleCorners } from 'pages/special/OsloDesignFair/map/standUtils';

export function getFeature_IndoorStandSymbol(
    marker: F_MapMarkerIndoorStandFragment,
    selectedIds: string[],
    forceSelect: boolean,
    opacity?: number
): GeoJSON.Feature {
    const isSelected = forceSelect || selectedIds.includes(marker.id);

    return {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [marker.lng, marker.lat]
        },
        properties: {
            markerId: marker.id,
            text: marker.text,
            logoUrl: marker.logoUrl,
            circleColor: marker.darkColor,
            labelColor: marker.darkColor,
            haloColor: isSelected ? 'yellow' : '#fff',
            opacity: opacity ?? 1
        }
    };
}

export function getFeature_IndoorStandMarkerWallInner(
    marker: F_MapMarkerIndoorStandFragment
): GeoJSON.Feature {
    const coordinate = { lat: marker.lat, lng: marker.lng };

    const coordinates = calculateRectangleCorners(
        coordinate,
        marker.width,
        marker.height,
        marker.rotation
    );

    return {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [fromLatLngToCoordinates(coordinates)]
        },
        properties: {
            markerId: marker.id,
            color: marker.color,
            height: 0.7,
            base_height: 0
        }
    };
}

export function getFeature_IndoorStandMarkerWallOuter(
    marker: F_MapMarkerIndoorStandFragment,
    selectedIds: string[]
): GeoJSON.Feature {
    const coordinate = { lat: marker.lat, lng: marker.lng };

    const isSelected = selectedIds.includes(marker.id);

    const coordinates = calculateRectangleCorners(
        coordinate,
        marker.width + 0.3,
        marker.height + 0.3,
        marker.rotation
    );

    return {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [fromLatLngToCoordinates(coordinates)]
        },
        properties: {
            markerId: marker.id,
            color: isSelected ? 'yellow' : '#fff',
            height: 0.5,
            base_height: 0
        }
    };
}
